<template>
  <div>
    <div class=" justify-content-between align-items-center">
        <div class="d-flex mb-3">
            <input type="text" class="form-control"  v-model="searchInput" @input="onUserTyping" placeholder="Rechercher...">
            <button class="btn btn-primary ms-2" @click="toggleFiltersPanel">
                <i class="fe fe-filter"></i> Filtres
                <span v-if="tags.length" class="badge bg-white text-primary ms-1">{{ tags.length }}</span>
            </button>
            <!-- <button class="btn btn-success ms-2" @click="exportCSV">Exporter CSV</button> -->
        </div>
    </div>
    <div v-show="showFiltersPanel" class="expanel expanel-default">
        <div class="expanel-body">
            <div class="text-wrap">
            <div class="btn-group mt-2 mb-2">
                <button class="btn btn-outline-primary dropdown-toggle" @click="toggleDropdown">Ajouter un filtre</button>

                <ul class="dropdown-menu" :class="{ 'd-block': dropdownVisible && currentView === 'main' }">
                <li v-for="filter in filterableFields" :key="filter.key">
                    <a class="dropdown-item" href="#" @click.prevent="openSubmenu(filter.key)">
                    {{ filter.label }} <i class="fe fe-chevron-right float-end"></i>
                    </a>
                </li>
                </ul>

                <div class="dropdown-menu p-3" v-for="filter in filterableFields" :key="filter.key" :class="{ 'd-block': dropdownVisible && currentView === filter.key }">
                <button class="btn btn-sm btn-light mb-2" @click="backToMain">← Retour</button>
                <form @submit.prevent="applyFilter(filter.key)">
                    <!-- SELECT avec <statut> -->
                    <div class="mb-2" v-if="filter.type === FILTER_TYPES.STATUT">
                    <span
                        v-for="opt in filter.options" :key="opt.value"
                        class="badge rounded-pill badge-sm me-1 mb-1 mt-1"
                        :class="{ 'bg-primary text-white': String(filtersDraft[filter.key]) === String(opt.value),
                        'badge-outline text-primary border border-primary': String(filtersDraft[filter.key]) !== String(opt.value) }"
                        style="cursor: pointer" @click="toggleOption(filter.key, opt.value)">
                        {{ opt.label }}
                    </span>
                    </div>

                    <!-- SELECT avec <select> -->
                    <div class="mb-2" v-if="filter.type === FILTER_TYPES.SELECT">
                    <label :for="'select-' + filter.key" class="form-label">{{ filter.label }}</label>
                    <select
                        :id="'select-' + filter.key"
                        class="form-control form-select"
                        v-model="filtersDraft[filter.key]"
                    >
                        <option value="">-- Sélectionnez --</option>
                        <option v-for="opt in filter.options" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                        </option>
                    </select>
                    </div>

                    <!-- TEXT -->
                    <div class="mb-2" v-else-if="filter.type === FILTER_TYPES.TEXT">
                    <input
                        type="text"
                        class="form-control"
                        v-model="filtersDraft[filter.key]"
                        :placeholder="filter.placeholder"
                    />
                    </div>

                    <!-- DATE -->
                    <div class="mb-2" v-else-if="filter.type === FILTER_TYPES.DATE">
                    <input
                        type="date"
                        class="form-control"
                        v-model="filtersDraft[filter.key]"
                    />
                    </div>
                    <button  class="btn btn-sm btn-primary w-100" type="submit"><span class="fe fe-search"></span> Appliquer</button>
                </form>
                </div>
            </div>

            <div class="btn-group mt-2 mb-2">
                <div class="tags mb-2 ms-2">
                <span class="tag tag-radius tag-round tag-primary" v-for="(tag, index) in tags" :key="index">
                    {{ tag.name }} : {{ tag.value }}
                    <a href="javascript:void(0)" class="tag-addon" @click="removeTag(index)">
                    <i class="fe fe-x"></i>
                    </a>
                </span>
                </div>
            </div>

            </div>
        </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import {FILTER_TYPES} from "../helpers/constants";

export default {
    name: "FiltersTable",
    props: {
        items: {
            content: [],
            totalPages: '',
            totalElements: '',
            number: '',
        },
        filterableFields: Array,
        searchField: {
            type: String,
            default: null
        },
        pageSize: {
        type: Number,
        default: 10
      },
    },
    data() {
      return {
        filters: {},
        filtersDraft: {},
        tags: [],
        currentView: 'main',
        dropdownVisible: false,
        showFiltersPanel: false,
        searchInput: '',
        internalSearch: '',
        isSearching : false,
        page: 0,
        totalPages: 0,
        totalElements: 0,
      };
    },
    computed: {
      FILTER_TYPES() {
        return FILTER_TYPES
      },

      startEntry() {
        return this.totalElements === 0 ? 0 : this.page * this.pageSize + 1;
      },
      endEntry() {
        const end = (this.page + 1) * this.pageSize;
        return end > this.totalElements ? this.totalElements : end;
      }

    },
    methods: {
        loadData() {
            this.$loading(true);
            const params = {
            page: this.page,
            size: this.pageSize,
            ...this.filters
            };

            const isSearchFieldInFilters = this.searchField && Object.keys(this.filters).includes(this.searchField)

            if (!isSearchFieldInFilters && this.searchField && this.internalSearch) {
            params[this.searchField] = this.internalSearch
            }
            this.totalPages = this.items.totalPages;
            this.totalElements = this.items.totalElements;
            this.page = this.items.number;
            this.$loading(false);
        },
        toggleOption(fieldKey, value) {
            const current = this.filtersDraft[fieldKey];
            if (String(current) === String(value)) {
            this.$set(this.filtersDraft, fieldKey, null);
            } else {
            this.$set(this.filtersDraft, fieldKey, value);
            }
            this.$forceUpdate();
        },
        changePage(newPage) {
            if (newPage >= 0 && newPage < this.totalPages) {
            this.page = newPage;
            this.loadData();
            }
        },
        handleSearch: debounce(function () {
            this.isSearching = false;
            this.internalSearch = this.searchInput;
            this.page = 0;
            this.loadData();
        }, 1000),
        openSubmenu(key) {
            this.currentView = key;
            this.dropdownVisible = true;
        },
        backToMain() {
            this.currentView = 'main';
            this.dropdownVisible = false;
        },
        toggleFiltersPanel() {
            this.showFiltersPanel = !this.showFiltersPanel;
        },
        toggleDropdown() {
            this.dropdownVisible = !this.dropdownVisible;
            this.currentView = 'main';
        },
        applyFilter(fieldKey) {
        const value = this.filtersDraft[fieldKey];
        if (value === null || value === undefined || value === '') return;

        this.$set(this.filters, fieldKey, value);
        this.filters[fieldKey] = value;

        const existing = this.tags.findIndex(t => t.name === fieldKey);
        const label = value;

        if (existing !== -1) this.tags.splice(existing, 1, { name: fieldKey, value: label });
        else this.tags.push({ name: fieldKey, value: label });

        this.dropdownVisible = false;
        this.currentView = 'main';
        this.page = 0;
        this.loadData();
      },
      removeTag(index) {
        const removedTag = this.tags[index];
        if (removedTag && removedTag.name) {
          this.$delete(this.filters, removedTag.name);
          this.$delete(this.filtersDraft, removedTag.name);
          this.page = 0;
          this.loadData();
        }

        this.tags.splice(index, 1);
      },
      handleOutsideClick(event) {
        const dropdown = this.$el.querySelector('.btn-group');
        if (dropdown && !dropdown.contains(event.target)) {
          this.dropdownVisible = false;
          this.currentView = 'main';
        }
      },
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
        this.loadData();
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleOutsideClick);
    },
}
</script>

<style>

</style>